// loadComponent comunica con la libreria npm che abbiamo installato, qui stiamo importando McElement che in sostanza estende HTMLElement (lo trovi nella sezione test)
// tutti i componenti che ti servono vanno chiamati così, con /components/nome-componente.js se sono su npm, li trovi tutti nella tab Componenti in sezione test
await loadComponent("./components/mc-element.js", false);

// queste sono le uniche librerie che hanno "res" invece che "components", le ho messe qua solo per farti vedere come si importano
await loadComponent("./res/mc-utils.js", false); // la trovi documentata sulla tab McUtils nella sezione test
await loadComponent("./res/mc-events.js", false); // la trovi documentata sulla tab Eventi nella sezione test
await loadComponent("./res/mc-shopify.js", false); // la trovi documentata sulla tab McShopify nella sezione test

class ProductCard extends McElement {
  connectedCallback() {
    this.cmpLoad();
    this.btnCart();
    this.selectVariant();
  }

  //Evento caricamento pagina
  cmpLoad() {
    const card = this;
    const swiperEl = card.querySelector(".swiper");
    const form = card.querySelector("form");
    const addBtn = card.querySelector("[data-add-to-cart]");
    const mobileTrigger = card.querySelector("[data-open-variant-selector]");

    // GALLERY MOVEMENT SOLO SULLA PRIMA CARD
    if (card.hasAttribute("data-first-card")) {
      if (swiperEl) {
        if (swiperEl.swiper) {
          requestAnimationFrame(() => {
            swiperEl.swiper.slideTo(1, 300);
            setTimeout(() => swiperEl.swiper.slideTo(0, 300), 800);
          });
        } else {
          swiperEl.addEventListener(
            "swiper:init",
            () => {
              requestAnimationFrame(() => {
                swiperEl.swiper.slideTo(1, 300);
                setTimeout(() => swiperEl.swiper.slideTo(0, 300), 800);
              });
            },
            { once: true }
          );
        }
      }
    }

    // AGGIUNTA AL CARRELLO DESKTOP
    if (addBtn && form) {
      addBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (typeof McShopify?.addToCart === "function") {
          McShopify.addToCart(form);
        }
      });
    }
  }

  //Evento per l'aggiunta del prodotto al carello
  btnCart() {
    const trigger = this.querySelector(".product-card__cart-icon");
    trigger?.addEventListener("click", () => {
      document.dispatchEvent(
        new CustomEvent("open-variant-selector", {
          detail: {
            productUrl: trigger.dataset.productUrl,
          },
        })
      );
    });
  }

  //Evento per la gestione della selezione della variante
  selectVariant() {
    document.querySelectorAll("product-card").forEach((card) => {
      const form = card.querySelector("form");
      const radios = card.querySelectorAll('input[type="radio"]');

      // Quando una variante viene selezionata
      radios.forEach((radio) => {
        radio.addEventListener("change", () => {
          // Rimuovi tutti gli .active nella stessa card
          card.querySelectorAll(".variant-label").forEach((label) => {
            label.classList.remove("active");
          });

          // Aggiungi .active solo al label selezionato
          const selectedLabel = card.querySelector(`label[for="${radio.id}"]`);
          if (selectedLabel) selectedLabel.classList.add("active");
        });
      });

      // Quando il form viene inviato, togli l'evidenza
      if (form) {
        form.addEventListener("submit", () => {
          card.querySelectorAll(".variant-label").forEach((label) => {
            label.classList.remove("active");
          });
        });
      }
    });
  }
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}

window.ProductCard = ProductCard;
